import { useCallback, useEffect, useRef, useState } from "react";
import { PageLocationTitle, StatusButton } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Swal from "sweetalert2";
import { HistoryModal } from "src/components/atoms/historyModal";
import HistoryIcon from "@mui/icons-material/History";
import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  Container,
  Zoom,
  Fab,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Tooltip,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import CollapseText from "src/components/atoms/colapso-text";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import Navbar from "src/components/organisms/navbar";
import Highlighter from "react-highlight-words";

import CheckroomIcon from "@mui/icons-material/Checkroom";
import { ShirtsModal } from "src/components/atoms/shirtsModal";
import { EditShirtModal } from "src/components/atoms/editShirtModal";

const SubscriptionEvents = () => {
  const location = useLocation();
  const tournamentsSearchState = location?.state?.selectedTournaments;
  const editedEnrollmentId = location?.state?.enrollmentId;
  const [data, setData] = useState<any[]>([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const { getToken } = useAuthenticate();
  const [visible, setVisible] = useState(false);
  const [tournaments, setTournaments] = useState<any[]>([]);
  const [tournamentsMap, setTournamentsMap] = useState<any>({});
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [search, setSearch] = useState<string>(editedEnrollmentId || "");
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [manualPayments, setManualPayments] = useState<any>([]);
  const [autoPayments, setAutoPayments] = useState<any>([]);
  const [paidSubs, setPaidSubs] = useState(0);
  const [unpaidSubs, setUnpaidSubs] = useState(0);
  const [searchPaymentStatus, setSearchPaymentStatus] = useState<string>("");
  const [selectedTournaments, setSelectedTournaments] = useState<any[]>(
    tournamentsSearchState ? tournamentsSearchState : []
  );
  const [tournamentsSearch, setTournamentsSearch] = useState<number[]>(
    tournamentsSearchState
      ? tournamentsSearchState?.map((item: any) => item.id)
      : []
  );
  const url = window.location.pathname;
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const navigate = useNavigate();
  const [showShirtsModal, setShowShirtsModal] = useState<boolean>(false);
  const [editShirtModalOpen, setEditShirtModalOpen] = useState(false);
  const [editShirtSubs, setEditShirtSubs] = useState<any>(null);
  const [editShirtSlug, setEditShirtSlug] = useState("");

  const handleEditFighter = async (fighterId: number, slug: string) => {
    await Swal.fire({
      title: "Como deseja editar sua inscrição?",
      text: "Você pode editar seguindo as regras do evento ou livremente.",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: "#373737",
      confirmButtonText: "Editar com regras",
      denyButtonText: "Editar sem regras",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed)
        navigate(`/enrollment-update/${fighterId}/${slug}`, {
          state: { from: url, mode: "regras" },
        });
      else if (result.isDenied)
        navigate(`/enrollment-update/${fighterId}/${slug}`, {
          state: { from: url, mode: "livre" },
        });
    });
  };

  const changePayments = async (
    slug: any,
    status: boolean,
    fighter: number
  ) => {
    await Swal.fire({
      title: "Tem certeza que deseja mudar a status de pagamento?",
      icon: "warning",
      showDenyButton: true,
      showCancelButton: false,
      html:
        '<input type="text" id="paymentAmount" placeholder="Digite o valor do pagamento (ex: 150.00)" class="swal2-input" inputmode="decimal" required>' +
        '<input type="text" id="paymentObservation" placeholder="Observação (opcional)" class="swal2-input">',
      confirmButtonText: "Sim",
      denyButtonText: "Não",
      didOpen: () => {
        const input = document.getElementById("paymentAmount") as HTMLInputElement;
        if (input) {
          input.addEventListener("input", () => {
            input.value = input.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
          });
        }
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        const paymentAmountInput = document.getElementById(
          "paymentAmount"
        ) as HTMLInputElement;
        const paymentObservationInput = document.getElementById(
          "paymentObservation"
        ) as HTMLInputElement;
        if (paymentAmountInput && paymentAmountInput.checkValidity()) {
          const paymentAmount = paymentAmountInput.value;
          const observation = paymentObservationInput?.value || undefined;

          await api
            .patch(
              `managers/tournaments/${slug}/payments`,
              {
                status: !status,
                paymentId: fighter,
                valueSubscription: paymentAmount,
                ...(observation && { observation }),
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getToken()}`,
                },
              }
            )
            .then((response) => {
              if (response.status === 200) {
                const newList: any = data.map((item: any) => {
                  if (item.id === fighter) {
                    const updatedItem = {
                      ...item,
                      status: !item.status,
                      valueSubscription: paymentAmount,
                      observation: observation || item.observation,
                    };

                    return updatedItem;
                  }

                  return item;
                });

                setData(newList);
                getPaymentsInfo(
                  selectedTournaments.map((item: any) => item.id)
                );

                toast.success("Status de pagamento alterado com sucesso!");
              }
            })
            .catch((error) =>
              Swal.fire({
                title: "Inscrição paga automaticamente",
                text:
                  error.response?.data?.message ||
                  "Não foi possível mudar status de pagamento!",
                icon: "error",
              })
            );
        } else {
          toast.error("Status não alterado, informe o valor de pagamento");
        }
      }
    });
  };

  const handleChangePaymentStatus = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setSearchPaymentStatus(newAlignment);
    fetchSubs(1, tournamentsSearch, false, search, newAlignment);
  };

  const fetchSubs = useCallback(
    async (
      pageNumber = 1,
      tournaments: number[] = [],
      append = false,
      search = "",
      paymentStatus = ""
    ) => {
      setIsLoaded(false);

      if (tournaments.length === 0) {
        return;
      }

      if (loadingMore) return;
      setLoadingMore(true);

      try {
        const response = await api.get(
          `/administrators/tournaments/enrollments?${new URLSearchParams({
            page: pageNumber.toString(),
            limit: "10",
            tournaments: tournaments?.join(","),
            search: search,
            paymentStatus: paymentStatus,
          })}`,
          {
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );

        const newSubs = response.data.subscriptions;
        setData((prev: any) => (append ? [...prev, ...newSubs] : newSubs));
        setPage(+response.data.meta.page);
        setTotal(response.data.meta.total);
        setLastPage(response.data.meta.lastPage);
      } catch (error: any) {
        console.log(error);
        toast.error(
          error.response?.data?.message || "Erro ao carregar suas inscrições"
        );
      } finally {
        setInitialLoading(false);
        if (search !== "") setIsLoaded(true);
        setLoadingMore(false);
      }
    },
    [getToken, loadingMore]
  );

  const mountTournamentsSearch = () => {
    setLoadingMore(true);

    api
      .get("/managers/tournaments/info/me", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        const arr = response.data;
        const map: Record<number, any> = {};
        arr.forEach((t: any) => {
          map[t.id] = t;
        });

        setTournaments(arr);
        setTournamentsMap(map);
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const getPaymentsInfo = (tournamentIds: number[]) => {
    if (tournamentIds.length === 0) {
      return;
    }

    api
      .get(`/administrators/tournaments/payment/infos/${tournamentIds}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        setUnpaidSubs(response.data.totalUnpaid);
        setPaidSubs(response.data.totalPaid);
        setManualPayments(response.data.resultManual);
        setAutoPayments(response.data.resultAuto);
      });
  };

  const showHistorySubsModal = async (subscriptionId: number) => {
    await api
      .get(`/history/Subscription/${subscriptionId}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        setHistoryData(res.data);
        setIsModalOpen(true);
      });
  };

  const parseNumericValue = (value: string): number | null => {
    if (!value) return null;

    // remove espaços extras
    const trimmed = value.trim();

    // ✅ só aceita se a string for APENAS número (com vírgula ou ponto)
    const match = trimmed.match(/^\d+(?:[.,]\d+)?$/);
    if (!match) return null;

    const cleaned = trimmed.replace(/\./g, "").replace(",", ".");
    const parsed = parseFloat(cleaned);

    return isNaN(parsed) ? null : parseFloat(parsed.toFixed(2));
  };

  const formatNumber = (occurrences: number, value: string) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const numericValue = parseNumericValue(value);

    if (numericValue !== null) {
      const total = occurrences * numericValue;
      return `${occurrences} - ${formatter.format(
        numericValue
      )} = ${formatter.format(total)}`;
    }

    return `${occurrences} - ${value}`;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tournaments.length === 0) {
      mountTournamentsSearch();
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tournamentsSearchState) {
      const formatedIds = tournamentsSearchState.map((teste: any) => teste.id);
      fetchSubs(1, formatedIds, true, search);
      getPaymentsInfo(formatedIds);
    }

    if (tournamentsSearchState) {
      navigate(location.pathname, { replace: true, state: {} }); // limpa o state no histórico
    }
  }, []);

  const handleShowShirtsModal = () => {
    setShowShirtsModal(true);
  };

  const handleCloseShirtsModal = () => {
    setShowShirtsModal(false);
  };

  // observer para infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && page < lastPage && !initialLoading) {
          fetchSubs(
            page + 1,
            tournamentsSearch,
            true,
            search,
            searchPaymentStatus
          );
        }
      },
      { threshold: 0 }
    );

    const currentLoaderRef = loaderRef.current;

    if (currentLoaderRef) {
      observer.observe(currentLoaderRef);
    }

    return () => {
      if (observer && currentLoaderRef) {
        try {
          observer.unobserve(currentLoaderRef);
        } catch {}
      }
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, lastPage, tournamentsSearch, fetchSubs, initialLoading]);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSearch = () => {
    fetchSubs(1, tournamentsSearch, false, search, searchPaymentStatus);
  };

  const allOptions = { id: "all", name: "TODOS" };

  return (
    <>
      <Navbar />
      <Container>
        <Box sx={{ mt: 2 }}>
          <PageLocationTitle>Gerenciar pagamentos</PageLocationTitle>
        </Box>

        {loadingMore && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center", // centraliza horizontalmente
              alignItems: "center", // centraliza verticalmente
              backdropFilter: "blur(6px)", // 👈 aplica o blur no fundo
              backgroundColor: "rgba(255, 255, 255, 0.4)", // leve transparência
              zIndex: 2000, // garante que fica acima de tudo
              gap: 2,
            }}
          >
            <Typography
              sx={{ fontFamily: "Inter, sans-serif", fontSize: "1.1rem" }}
            >
              Aguarde, estamos carregando suas inscrições...
            </Typography>

            <CircularProgress sx={{ color: "black" }} />
          </Box>
        )}

        <Autocomplete
          multiple
          options={[...tournaments, allOptions]}
          getOptionLabel={(option) => option.name}
          value={selectedTournaments}
          onChange={(event, newValue) => {
            if (newValue.length === 0) {
              setTournamentsSearch([]);
              setSelectedTournaments([]);
              setAutoPayments([]);
              setManualPayments([]);
              setUnpaidSubs(0);
              setTotal(0);
              setPage(0);
              setPaidSubs(0);
              setData([]);
            }

            if (newValue.some((val) => val.id === "all")) {
              // se clicou em "Selecionar todos", marca todos
              const tounamentIds = tournaments.map((value: any) => value.id);
              setTournamentsSearch(tounamentIds);
              fetchSubs(1, tounamentIds, false, undefined, searchPaymentStatus);
              getPaymentsInfo(tounamentIds);
              setSelectedTournaments(tournaments);
            } else {
              const tounamentIds = newValue.map((value) => value.id);
              setTournamentsSearch(tounamentIds);
              setSelectedTournaments(newValue);
              fetchSubs(1, tounamentIds, false, undefined, searchPaymentStatus);
              getPaymentsInfo(tounamentIds);
            }
          }}
          renderValue={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                onClick={() => undefined}
                sx={{ cursor: "default" }}
                label={option.name}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Digite para buscar torneios..."
              variant="outlined"
              size="small"
              //error={selectedTournaments.length === 0}
              //helperText={selectedTournaments.length === 0 ? "Selecione pelo menos um torneio" : ""}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                },
              }}
            />
          )}
          filterOptions={(options, { inputValue }) => {
            return options.filter((option) =>
              option.name.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
          noOptionsText="Nenhum torneio encontrado"
          loadingText="Carregando torneios..."
          sx={{
            mt: 1,
            "& .MuiAutocomplete-paper": {
              backgroundColor: "white",
            },
          }}
        />

        {selectedTournaments.length > 0 && (
          <>
            <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "rgb(132, 140, 155)",
                  fontFamily: "inter, sans-serif",
                }}
              >
                <span translate="no">{total} INSCRIÇÕES ENCONTRADAS</span>
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "rgb(132, 140, 155)",
                  fontFamily: "inter, sans-serif",
                }}
              >
                <span translate="no">{unpaidSubs} INSCRIÇÕES NÃO PAGAS</span>
              </Typography>
              <CollapseText title={<span translate="no">{paidSubs} INSCRIÇÕES PAGAS</span>}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    color: "black",
                    fontWeight: 700,
                    fontFamily: "inter, sans-serif",
                  }}
                >
                  PAGAMENTOS MANUAIS
                </Typography>

                {manualPayments.length > 0 ? (
                  <>
                    {Object.values(
                      manualPayments.reduce((acc: any, item: any) => {
                        const numericValue = parseNumericValue(item.value);

                        // se for número → agrupa pelo número
                        if (numericValue !== null) {
                          if (!acc[numericValue]) {
                            acc[numericValue] = {
                              ...item,
                              value: numericValue,
                              occurrences: 0,
                            };
                          }
                          acc[numericValue].occurrences += item.occurrences;
                        } else {
                          // se for string → agrupa pelo texto original
                          if (!acc[item.value]) {
                            acc[item.value] = { ...item, occurrences: 0 };
                          }
                          acc[item.value].occurrences += item.occurrences;
                        }

                        return acc;
                      }, {})
                    )
                      .sort((a: any, b: any) => b.occurrences - a.occurrences)
                      .map((item: any) => (
                        <Typography
                          key={`${item.occurrences}-${item.value}`}
                          variant="subtitle1"
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "rgb(132, 140, 155)",
                            fontFamily: "inter, sans-serif",
                          }}
                        >
                          <span translate="no">{formatNumber(item.occurrences, String(item.value))}</span>
                        </Typography>
                      ))}

                    {/* Total exibido apenas uma vez */}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "black",
                        fontFamily: "inter, sans-serif",
                        mt: 1,
                      }}
                    >
                      <span translate="no">{"TOTAL: "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        manualPayments.reduce((acc: number, item: any) => {
                          const numericValue = parseNumericValue(item.value);
                          return numericValue !== null
                            ? acc + item.occurrences * numericValue
                            : acc;
                        }, 0)
                      )}</span>
                    </Typography>
                  </>
                ) : (
                  <Typography variant="subtitle2" sx={{ color: "black" }}>
                    Nenhum pagamento encontrado
                  </Typography>
                )}

                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    color: "black",
                    fontWeight: 700,
                    fontFamily: "inter, sans-serif",
                    mt: 1,
                  }}
                >
                  PAGAMENTOS AUTOMÁTICOS
                </Typography>

                {autoPayments.length > 0 ? (
                  <>
                    {Object.values(
                      autoPayments.reduce((acc: any, item: any) => {
                        const numericValue = parseNumericValue(item.value);

                        // se for número → agrupa pelo número
                        if (numericValue !== null) {
                          if (!acc[numericValue]) {
                            acc[numericValue] = {
                              ...item,
                              value: numericValue,
                              occurrences: 0,
                            };
                          }
                          acc[numericValue].occurrences += item.occurrences;
                        } else {
                          // se for string → agrupa pelo texto original
                          if (!acc[item.value]) {
                            acc[item.value] = { ...item, occurrences: 0 };
                          }
                          acc[item.value].occurrences += item.occurrences;
                        }

                        return acc;
                      }, {})
                    )
                      .sort((a: any, b: any) => b.occurrences - a.occurrences)
                      .map((item: any) => (
                        <Typography
                          key={`${item.occurrences}-${item.value}`}
                          variant="subtitle1"
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "rgb(132, 140, 155)",
                            fontFamily: "inter, sans-serif",
                          }}
                        >
                          <span translate="no">{formatNumber(item.occurrences, String(item.value))}</span>
                        </Typography>
                      ))}

                    {/* Total exibido apenas uma vez */}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "black",
                        fontFamily: "inter, sans-serif",
                        mt: 1,
                      }}
                    >
                      <span translate="no">{"TOTAL: "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        autoPayments.reduce((acc: number, item: any) => {
                          const numericValue = parseNumericValue(item.value);
                          return numericValue !== null
                            ? acc + item.occurrences * numericValue
                            : acc;
                        }, 0)
                      )}</span>
                    </Typography>
                  </>
                ) : (
                  <Typography variant="subtitle2" sx={{ color: "black" }}>
                    Nenhum pagamento encontrado
                  </Typography>
                )}

                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    color: "black",
                    fontWeight: 700,
                    fontFamily: "inter, sans-serif",
                    mt: 1,
                  }}
                >
                  PAGAMENTOS TOTAIS
                </Typography>

                {[...manualPayments, ...autoPayments].length > 0 ? (
                  <>
                    {Object.values(
                      [...manualPayments, ...autoPayments].reduce(
                        (acc: any, item: any) => {
                          const numericValue = parseNumericValue(item.value);

                          // se for número → agrupa pelo número
                          if (numericValue !== null) {
                            if (!acc[numericValue]) {
                              acc[numericValue] = {
                                ...item,
                                value: numericValue,
                                occurrences: 0,
                              };
                            }
                            acc[numericValue].occurrences += item.occurrences;
                          } else {
                            // se for string → agrupa pelo texto original
                            if (!acc[item.value]) {
                              acc[item.value] = { ...item, occurrences: 0 };
                            }
                            acc[item.value].occurrences += item.occurrences;
                          }

                          return acc;
                        },
                        {}
                      )
                    )
                      .sort((a: any, b: any) => b.occurrences - a.occurrences)
                      .map((item: any) => (
                        <Typography
                          key={`all-${item.occurrences}-${item.value}`}
                          variant="subtitle1"
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "rgb(132, 140, 155)",
                            fontFamily: "inter, sans-serif",
                          }}
                        >
                          <span translate="no">{formatNumber(item.occurrences, String(item.value))}</span>
                        </Typography>
                      ))}

                    {/* Total exibido apenas uma vez */}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "black",
                        fontFamily: "inter, sans-serif",
                        mt: 1,
                      }}
                    >
                      <span translate="no">{"TOTAL: "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        [...manualPayments, ...autoPayments].reduce(
                          (acc: number, item: any) => {
                            const numericValue = parseNumericValue(item.value);
                            return numericValue !== null
                              ? acc + item.occurrences * numericValue
                              : acc;
                          },
                          0
                        )
                      )}</span>
                    </Typography>
                  </>
                ) : (
                  <Typography variant="subtitle2" sx={{ color: "black" }}>
                    Nenhum pagamento encontrado
                  </Typography>
                )}
              </CollapseText>
              {selectedTournaments.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  <Chip
                    label="Relatório de pagamentos manuais"
                    size="small"
                    clickable
                    onClick={() =>
                      navigate(
                        url.includes("/admin/")
                          ? "/admin/manual-payments-report"
                          : "/tournament/manual-payments-report",
                        { state: { selectedTournaments } }
                      )
                    }
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      height: 24,
                      backgroundColor: "#eef0f5",
                      color: "#4e5672",
                      "&:hover": { backgroundColor: "#1a2252", color: "#fff" },
                    }}
                  />
                </Box>
              )}
            </Box>
            <Box sx={{ display: "flex", mt: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Digite nome, academia, faixa, categoria..."
                value={search}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setIsLoaded(false);
                    fetchSubs(
                      1,
                      tournamentsSearch,
                      false,
                      undefined,
                      searchPaymentStatus
                    );
                  }
                  setSearch(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={handleSearch}>
                        <SearchIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ display: "flex", mt: 2 }}>
              <ToggleButtonGroup
                color="standard"
                value={searchPaymentStatus}
                exclusive
                onChange={handleChangePaymentStatus}
                aria-label="Platform"
              >
                <ToggleButton value="">Todas</ToggleButton>
                <ToggleButton value="true">Pagas</ToggleButton>
                <ToggleButton value="false">Não pagas</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <Button
              sx={{
                mt: 2,
                fontFamily: "inter, sans-serif",
                backgroundColor: "#373737",
                color: "white",
              }}
              onClick={() => handleShowShirtsModal()}
            >
              Relatório de camisas
            </Button>
          </>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          {data.map((subs: any) => {
            const tournamentInfo = tournamentsMap[subs.tournamentId];
            return (
              <Paper
                key={subs.id}
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" }, // <-- muda conforme tamanho
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" }, // ajusta alinhamento no mobile
                  gap: 2, // adiciona espaçamento entre colunas
                }}
              >
                {/* Coluna esquerda */}
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Typography
                    sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}
                  >
                    <span>{`Inscrição Nº ${subs.id} - ${tournamentInfo.name}`}</span>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      fontWeight: 700,
                      color: subs.status ? "green" : "red",
                    }}
                  >
                    <span translate="no"><strong>Valor:</strong>{` R$ ${subs.valueSubscription}`}</span>
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      fontSize: "0.85rem",
                      color: "#666",
                    }}
                  >
                    <strong>Obs:</strong> {subs.observation || "Sem observação"}
                  </Typography>

                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Nome:</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.fighters
                            ? subs?.fighters?.name?.toUpperCase()
                            : subs?.user?.name?.toUpperCase()
                        }
                      />
                    ) : subs.fighters ? (
                      subs?.fighters?.name?.toUpperCase()
                    ) : (
                      subs?.user?.name?.toUpperCase()
                    )}</span>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <span><strong>Contato:</strong></span>
                    <Link
                      href={`https://wa.me/55${
                        subs.fighters
                          ? subs?.fighters?.phone?.replace(/\D/g, "")
                          : subs?.user?.phone?.replace(/\D/g, "")
                      }`} // remove tudo que não é número
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "#2576d3ff",
                      }}
                    >
                      <WhatsAppIcon fontSize="small" />
                      {isLoaded ? (
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[search]}
                          autoEscape={true}
                          textToHighlight={
                            subs.fighters
                              ? subs.fighters.phone
                              : subs.user.phone
                          }
                        />
                      ) : subs.fighters ? (
                        subs.fighters.phone
                      ) : (
                        subs.user.phone
                      )}
                    </Link>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Gênero:</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={subs.genre?.toUpperCase()}
                      />
                    ) : (
                      subs.genre?.toUpperCase()
                    )}</span>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Idade de luta:</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={subs.age + " anos"}
                      />
                    ) : (
                      subs.age + " anos"
                    )}</span>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Equipe:</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.fighters
                            ? subs?.fighters?.gym?.toLocaleUpperCase()
                            : subs?.user?.gym?.toLocaleUpperCase()
                        }
                      />
                    ) : subs.fighters ? (
                      subs?.fighters?.gym?.toLocaleUpperCase()
                    ) : (
                      subs?.user?.gym?.toLocaleUpperCase()
                    )}</span>
                  </Typography>

                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Responsável pela inscrição:</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={subs?.user?.name?.toUpperCase()}
                      />
                    ) : (
                      subs?.user?.name?.toUpperCase()
                    )}</span>
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <span><strong>Contato do responsável:</strong></span>
                    <Link
                      href={`https://wa.me/55${subs?.user?.phone?.replace(
                        /\D/g,
                        ""
                      )}`} // remove tudo que não é número
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "#2576d3ff",
                      }}
                    >
                      <WhatsAppIcon fontSize="small" />
                      {isLoaded ? (
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[search]}
                          autoEscape={true}
                          textToHighlight={subs.user.phone}
                        />
                      ) : (
                        subs.user.phone
                      )}
                    </Link>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Categoria(s):</strong>{" "}{isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.genre?.toUpperCase() +
                          ` (${subs?.category?.toUpperCase()})` +
                          ` / ${subs.belt?.toUpperCase()} / ${subs.weight?.toUpperCase()}`
                        }
                      />
                    ) : (
                      subs.genre?.toUpperCase() +
                      ` (${subs?.category?.toUpperCase()})` +
                      ` / ${subs.belt?.toUpperCase()} / ${subs.weight?.toUpperCase()}`
                    )}</span>
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {subs.tShirts ? (
                      <span><strong>Camisa:</strong>{" "}{`${subs.tShirts.measure?.toLocaleUpperCase()} (${subs.tShirts?.size.toLocaleUpperCase()}) - ${subs.tShirts.color?.toLocaleUpperCase()}`}</span>
                    ) : (
                      <span><strong>Camisa:</strong>{" "}Sem camisa</span>
                    )}
                    <Tooltip title={subs.paidAuto ? "Pagamento automático - camisa não editável" : (subs.tShirts ? "Editar camisa" : "Adicionar camisa")} arrow>
                      <CheckroomIcon
                        fontSize="small"
                        sx={{
                          cursor: subs.paidAuto ? "not-allowed" : "pointer",
                          color: subs.paidAuto ? "#ccc" : "#555",
                          "&:hover": { color: subs.paidAuto ? "#ccc" : "#000" },
                        }}
                        onClick={() => {
                          if (subs.paidAuto) return;
                          setEditShirtSubs(subs);
                          setEditShirtSlug(tournamentInfo.slug);
                          setEditShirtModalOpen(true);
                        }}
                      />
                    </Tooltip>
                  </Typography>
                </Box>

                {/* Coluna direita */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                    gap: 1,
                    mt: { xl: -20, xs: 0, sm: 0 },
                    width: { xs: "100%", sm: "auto" }, // botão ocupa toda a largura no celular
                    flexWrap: "wrap", // previne estouro em telas muito pequenas
                  }}
                >
                  {/* {subs.championGuarantee && (
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                      <Tooltip title="Este usuário adquiriu a garantia campeã!" arrow>
                        <EmojiEventsIcon color="warning" />
                      </Tooltip>
                    </Box>
                  )} */}

                  <Tooltip title="Editar inscrição" arrow>
                    <EditIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() =>
                        handleEditFighter(subs.id, tournamentInfo.slug)
                      }
                    />
                  </Tooltip>

                  <Tooltip title="Histórico de alterações" arrow>
                    <HistoryIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() => showHistorySubsModal(subs.id)}
                    />
                  </Tooltip>

                  <Tooltip title="Clique para mudar o status" arrow>
                    <StatusButton
                      role="button"
                      aria-disabled={subs.paidAuto}
                      status={subs.status}
                      disabled={subs.paidAuto}
                      onClick={() =>
                        changePayments(
                          tournamentInfo.slug,
                          subs.status,
                          subs.id
                        )
                      }
                    >
                      <span>
                        {subs.status
                          ? "Pagamento efetuado"
                          : "Pendente de pagamento"}
                      </span>
                    </StatusButton>
                  </Tooltip>
                </Box>
              </Paper>
            );
          })}
          <div ref={loaderRef} style={{ minHeight: 20 }} />
        </Box>
      </Container>

      <Zoom in={visible}>
        <Fab
          color="primary"
          size="medium"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            backgroundColor: "#373737",
            borderRadius: "50%",
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>

      <ShirtsModal
        showShirtsModal={showShirtsModal}
        handleCloseShirtsModal={handleCloseShirtsModal}
        tournaments={tournaments}
      />

      <HistoryModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        history={historyData}
        title="Inscrição"
        fieldLabels={{
          weight: "Peso",
          category: "Categoria",
          age: "Idade",
          belt: "Faixa",
          championGuarantee: "Garantia Campeão",
          camisa: "Camisa",
          camisa_preco: "Preço Camisa",
        }}
        hiddenFields={[
          "tournamentId",
          "valueSubscription",
          "combo_subscription",
          "userId",
          "genre",
          "fightersId",
          "status",
          "tShirtsId",
          "observation",
        ]}
      />

      {editShirtSubs && (
        <EditShirtModal
          open={editShirtModalOpen}
          onClose={() => {
            setEditShirtModalOpen(false);
            setEditShirtSubs(null);
          }}
          subscriptionId={editShirtSubs.id}
          slug={editShirtSlug}
          currentShirt={editShirtSubs.tShirts}
          onSuccess={(subscriptionId: number, newShirt: any) => {
            setData((prev: any) =>
              prev.map((item: any) =>
                item.id === subscriptionId
                  ? { ...item, tShirts: newShirt }
                  : item
              )
            );
          }}
        />
      )}
    </>
  );
};

export default SubscriptionEvents;
